export default __webpack_public_path__ + "media/b42ed00e49c3dfd6a591977d8c5f47af414c645af6b08b6e1b2367d56f6e3171.svg";